import type { ReactElement, ReactNode } from 'react';

import type { UiMode } from './ui-mode';

export function statusToneClass(status: string): string {
  const normalized = status.trim().toUpperCase();
  if (
    normalized === 'ACTIVE' ||
    normalized === 'IN_PROGRESS' ||
    normalized === 'APPROVED' ||
    normalized === 'COMPLETED' ||
    normalized === 'SENT' ||
    normalized === 'PUBLISHED' ||
    normalized === 'OPEN'
  ) {
    return 'status--active';
  }
  if (
    normalized === 'REJECTED' ||
    normalized === 'CANCELLED' ||
    normalized === 'FAILED' ||
    normalized === 'SEND_ERROR' ||
    normalized === 'CLOSED' ||
    normalized === 'INACTIVE'
  ) {
    return 'status--danger';
  }
  if (
    normalized === 'PENDING' ||
    normalized === 'DRAFT' ||
    normalized === 'SCHEDULED' ||
    normalized === 'WARNING'
  ) {
    return 'status--warning';
  }
  return 'status--neutral';
}

export function StatusChip(props: {
  readonly label: string;
  readonly tone?: string;
}): ReactElement {
  const tone = props.tone ?? statusToneClass(props.label);
  return <span className={`status-chip ${tone}`}>{props.label}</span>;
}

export function ModeSwitch(props: {
  readonly mode: UiMode;
  readonly onChange: (mode: UiMode) => void;
}): ReactElement {
  return (
    <div className="sidebar-mode-switch">
      <span className="mode-switch-label" id="ui-mode-label">
        Режим отображения
      </span>
      <div className="mode-segmented" role="group" aria-labelledby="ui-mode-label">
        <button
          type="button"
          className={props.mode === 'comfortable' ? 'mode-btn is-active' : 'mode-btn'}
          aria-pressed={props.mode === 'comfortable'}
          data-mode="comfortable"
          onClick={() => {
            props.onChange('comfortable');
          }}
        >
          Комфортный
        </button>
        <button
          type="button"
          className={props.mode === 'operational' ? 'mode-btn is-active' : 'mode-btn'}
          aria-pressed={props.mode === 'operational'}
          data-mode="operational"
          onClick={() => {
            props.onChange('operational');
          }}
        >
          Операционный
        </button>
      </div>
    </div>
  );
}

export function TechnicalDetails(props: { readonly children: ReactNode }): ReactElement {
  return (
    <details className="technical tech-details">
      <summary>Технические сведения</summary>
      <div className="tech-details-body">{props.children}</div>
    </details>
  );
}

export function PageHeader(props: {
  readonly title: string;
  readonly description?: ReactNode;
  readonly back?: { readonly label: string; readonly onClick: () => void };
}): ReactElement {
  return (
    <header className="page-header">
      {props.back !== undefined ? (
        <button type="button" className="back-link" onClick={props.back.onClick}>
          {props.back.label}
        </button>
      ) : null}
      <h1>{props.title}</h1>
      {props.description !== undefined && props.description !== null ? (
        <div className="page-description">{props.description}</div>
      ) : null}
    </header>
  );
}
